$(function () {
	// sticky header
	var observer = new IntersectionObserver(
		function (entries) {
			// no intersection with screen
			if (0 === entries[0].intersectionRatio) {
				document.querySelector('#headerBar').classList.add('sticky');
			}

			// fully intersects with screen
			else if (1 === entries[0].intersectionRatio) {
				document.querySelector('#headerBar').classList.remove('sticky');
			}
		},
		{
			threshold: [0, 1],
		}
	);

	// masks
	var maskBehavior = function (val) {
			return val.replace(/\D/g, '').length === 11
				? '(00) 00000-0000'
				: '(00) 0000-00009';
		},
		options = {
			onKeyPress: function (val, e, field, options) {
				field.mask(maskBehavior.apply({}, arguments), options);
			},
		};
	$('.form-tel').mask(maskBehavior, options);

	// Get container offset
	offsetWidth();
	$(window).resize(function () {
		offsetWidth();
	});

	function offsetWidth() {
		var containerOffset = $('.container').offset().left;
		$('.empreendimento-introducao-offset').css('width', containerOffset);
	}

	// Fancybox
	Fancybox.bind();

	// Single Link
	$('.single-link').bind('click', function (event) {
		var $anchor = $(this);

		$('html, body')
			.stop()
			.animate(
				{
					scrollTop: $($anchor.attr('href')).offset().top,
				},
				1000
			);

		event.preventDefault();
	});

	$(".toggle-form").click(function(event) {
		event.preventDefault();
		$(".contato-flutuante-box").slideToggle();
	});
});
